import axios from 'axios'
import qs from 'qs'
import { captureException } from '@sentry/browser'

const instance = axios.create({ withCredentials: true })

const serialize = (params) => {
  return qs.stringify(params, {
    arrayFormat: 'brackets',
    encodeValuesOnly: true
  })
}

const handle500Errors = (error) => {
  captureException(error, error.response)
}

const handleFailureResponse = (error) => {
  const status = error?.response?.status

  if (status >= 500) handle500Errors(error)

  return Promise.reject(error)
}

// Format nested params correctly
instance.interceptors.request.use((config) => {
  config.paramsSerializer = { serialize }

  return config
})

// Inject the storefront token
instance.interceptors.request.use((config) => {
  if (window.fingerprint) {
    config.headers.set('X-Booqable-Storefront-Token', window.fingerprint)
  }

  return config
})

instance.interceptors.response.use(
  // There is no need for special handling of successful responses
  undefined,
  handleFailureResponse
)

export default instance
